module.exports = __webpack_public_path__ + "img/asset_LARIX@2x.7dab5257.png";